import React from 'react';
import {Badge, Button} from 'react-bootstrap';
import {getUserFactoryId, getUser} from '../../../../../index';
import { generatePath, Link } from 'react-router-dom';


const StatusFormatter = (cellContent, row, standard, url) => {
    let retorno = [];
    retorno.push(
        <Link className="btn btn-primary" to={url}>
            Confirmar que realizei o treinamento
        </Link>
    );

    if (getUser().id === row.userId && !cellContent) {
        if (standard != null) {
            if (standard.status == 2) {
                return retorno
            }
            else
                return '';
        }    
        return retorno;
    
  } else {

    return (
      <Badge pill
             className="cursor-pointer"
             variant={cellContent ? 'success' : 'info'}>
        {cellContent ? 'Treinamento Concluído' : 'Não treinou ainda'}
      </Badge>
    );
  }
};

export default StatusFormatter;
